(function () {
    'use strict';

    angular.module("imApp").factory("visitorConfirmService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 118,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 119,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
